import React from "react";
import util from "../../../../../../../utils/es5Utils";
import _ from "underscore";

export const textscannerIcon =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024' fill='white'%3E%3Cpath transform='matrix(1,0,0,-1,0,960)' d='M320 832h-192v-192h-64v192c0 35.346 28.654 64 64 64h192v-64zM320 64h-192v192h-64v-192c0-35.345 28.654-64 64-64h192v64zM704 832h192v-192h64v192c0 35.346-28.655 64-64 64h-192v-64zM704 64h192v192h64v-192c0-35.345-28.655-64-64-64h-192v64zM224 615.321c0 17.673 14.327 32 32 32h384c17.673 0 32-14.327 32-32s-14.327-32-32-32h-384c-17.673 0-32 14.327-32 32zM224 448c0 17.673 14.327 32 32 32h512c17.673 0 32-14.327 32-32s-14.327-32-32-32h-512c-17.673 0-32 14.327-32 32zM224 280.678c0 17.673 14.327 32 32 32h320c17.673 0 32-14.327 32-32s-14.327-32-32-32h-320c-17.673 0-32 14.327-32 32z'/%3E%3C/svg%3E";

export default function TextScanner(props) {
    const widgets = util.widgetsOfType(props.context, "textscanner");
    const newProps = { ...props, widgets };
    const childComponents = _.values(props.childComponents).map((Component, id) => (
        <Component.component {...newProps} key={id} />
    ));

    if (widgets.length > 0 && childComponents.length > 0) {
        return [<label key="textScanner" text="Scanner" />, ...childComponents];
    }

    return null;
}
